import { render, staticRenderFns } from "./EditBtn.vue?vue&type=template&id=c2726600&scoped=true&"
import script from "./EditBtn.vue?vue&type=script&lang=ts&"
export * from "./EditBtn.vue?vue&type=script&lang=ts&"
import style0 from "./EditBtn.vue?vue&type=style&index=0&id=c2726600&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2726600",
  null
  
)

export default component.exports